export default {
  'inviteRebate.tabDeposit': 'Deposit Rebate',
  'inviteRebate.tabBet': 'Bet Rebate',
  'inviteRebate.tabWinLoss': 'Win/Loss Rebate',

  'inviteRebate.colSettleDate': 'Settle Date',
  'inviteRebate.colSettleMonth': 'Settle Month',
  'inviteRebate.colInviter': 'Inviter',
  'inviteRebate.colCoin': 'Currency',
  'inviteRebate.colHitTier': 'Hit Tier',
  'inviteRebate.tierN': 'Tier {n}',
  'inviteRebate.level1': 'Level 1',
  'inviteRebate.level2': 'Level 2',
  'inviteRebate.level3': 'Level 3',
  'inviteRebate.levelN': 'Level {n}',
  'inviteRebate.colDepositBase': 'Deposit Base',
  'inviteRebate.colBetBase': 'Valid Bet Base',
  'inviteRebate.colWinLossBase': 'Net Win/Loss Base',
  'inviteRebate.colCashAmount': 'Rebate Amount',
  'inviteRebate.colCashAmountTotal': 'Total',
  'inviteRebate.colCumulativeCash': 'Cumulative Rebate',
  'inviteRebate.colExtraAward': 'Extra Award',
  'inviteRebate.colAwardStatus': 'Status',
  'inviteRebate.awardStatus1': 'Pending',
  'inviteRebate.awardStatus2': 'Granted',
  'inviteRebate.awardStatus3': 'Rejected',
  'inviteRebate.colUpdateTime': 'Update Time',
  'inviteRebate.colOperation': 'Operation',
  'inviteRebate.colGameType': 'Venue Type',
  'inviteRebate.calcDetail': 'Calc Detail',
  'inviteRebate.calcDetailTitle': 'Rebate Calculation Detail',
  'inviteRebate.all': 'All',
  'inviteRebate.search': 'Search',
  'inviteRebate.reset': 'Reset',
  'inviteRebate.export': 'Export',
  'inviteRebate.exportEmpty': 'No data to export',
  'inviteRebate.operationFail': 'Operation failed',

  'inviteRebate.colFriendAccount': 'Friend Account',
  'inviteRebate.colLevel': 'Level',
  'inviteRebate.colBaseAmount': 'Base Amount',
  'inviteRebate.colRatio': 'Ratio',
  'inviteRebate.colContributedAmount': 'Contributed Amount',
  'inviteRebate.colFriendDetail': 'Friend Detail',
  'inviteRebate.ngrFriendDetailHint': 'Only friends with activity in the period (GGR / bonus / point exchange ≠ 0) are listed; each row is rounded separately, so the total may differ from the period commission by 0.01',
  'inviteRebate.colRemark': 'Remark',
  'inviteRebate.remarkPlaceholder': 'Optional remark when confirming/rejecting issuance (up to 200 chars)',
  'inviteRebate.extraAward': 'Extra Award',
  'inviteRebate.extraPoint': 'Points {n}',

  'inviteRebate.actionConfirmIssue': 'Confirm Issue',
  'inviteRebate.actionReject': 'Reject',
  'inviteRebate.confirmIssueTip': 'Confirm issuing this rebate? Cash will be credited immediately.',
  'inviteRebate.confirmIssueSuccess': 'Issued successfully',
  'inviteRebate.rejectIssueTip': 'Reject this rebate? It will not be issued.',
  'inviteRebate.rejectIssueSuccess': 'Rejected',
  'inviteRebate.tabNgr': 'NGR Rebate',
  'inviteRebate.colSettlePeriod': 'Settlement Period',
  'inviteRebate.settlePeriodTip': 'Filter by period start date (1st / 16th of each month)',
  'inviteRebate.colNgrBase': 'NGR Base',
  'inviteRebate.colPeriodCommission': 'Period Commission',
  'inviteRebate.colCarryIn': 'Carry-over',
  'inviteRebate.carryInFrom': 'from {{period}}',
  'inviteRebate.colPayable': 'Payable',
  'inviteRebate.awardStatus4': 'Nothing Payable · Carried Over',
  'inviteRebate.noPayableNote': 'Payable ≤ 0, not issued; negative carried over to the next period',
  'inviteRebate.colFriendGgr': 'Own GGR',
  'inviteRebate.colFriendBonus': 'Bonus Received',
  'inviteRebate.colFriendPointExchange': 'Points Redeemed',
};
